import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CartService } from 'src/app/services/cart.service';
import { EmailService } from 'src/app/services/email.service';
declare const gapi: any;

@Component({
  selector: 'app-chekout-page',
  templateUrl: './chekout-page.component.html',
  styleUrls: ['./chekout-page.component.scss'],
})
export class ChekoutPageComponent implements OnInit {
  cartItems: any[] = [];
  totalPrice: number = 0;
  CLIENT_ID = '<YOUR_CLIENT_ID>';
  API_KEY = '<YOUR_API_KEY>';
  SCOPES = 'https://www.googleapis.com/auth/gmail.send';

  addressForm: FormGroup;
  submitted = false;

  constructor(
    private cartService: CartService,
    private router: Router,
    private fb: FormBuilder,
    private emailService: EmailService
  ) {
    this.addressForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      streetAddress1: ['', Validators.required],
      streetAddress2: [''],
      postcode: [''],
      phone: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit() {
    // this.initGapi();
    this.cartItems = this.cartService.getCartItems();
    this.calculateTotalPrice();
  }

  initGapi() {
    gapi.load('client:auth2', () => {
      gapi.client
        .init({
          apiKey: this.API_KEY,
          clientId: this.CLIENT_ID,
          scope: this.SCOPES,
          discoveryDocs: [
            'https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest',
          ],
        })
        .then(() => {
          console.log('Google API initialized');
        });
    });
  }

  removeItem(productId: number) {
    this.cartService.removeProductFromCart(productId);
    this.cartItems = this.cartService.getCartItems();
    this.calculateTotalPrice();
  }

  calculateTotalPrice() {
    this.totalPrice = this.cartItems.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0
    );
  }

  placeOrder() {}

  onSubmit(): void {
    debugger;

    this.submitted = true;
    if (this.addressForm.valid) {
      this.sendEmail();
      console.log('Form Submitted', this.addressForm.value);
      this.cartItems.forEach((element) => {
        this.removeItem(element.id);
      });
      this.router.navigate(['/products']); // Navigate to the product page
    } else {
      console.log('Form Invalid');
    }
  }

  sendEmail_google() {
    const email = `
      To: 420@mailinator.com
      Subject: Test Email from Angular
      Content-Type: text/plain; charset="UTF-8"

      This is a test email sent from Angular.
    `;

    const base64EncodedEmail = btoa(email)
      .replace(/\+/g, '-')
      .replace(/\//g, '_');
    gapi.client.gmail.users.messages
      .send({
        userId: 'me',
        resource: {
          raw: base64EncodedEmail,
        },
      })
      .then((response: any) => {
        console.log('Email sent:', response);
      })
      .catch((error: any) => {
        console.error('Error sending email:', error);
      });
  }

  sendEmail() {
    debugger;
    const itemDetails = this.cartItems
      .map((item) => `${item.name} (x${item.quantity})`)
      .join(', ');
    const templateParams = {
      from_email: 'test8386911@gmail.com',
      items: this.cartItems,
      to_email: this.addressForm.value.email,
      from_name: 'Shivam food order online',
      subject: 'Your Food Order is Confirmed – We"ll Be in Touch Soon!',
      message: `Your Food Order is Confirmed – We"ll Be in Touch Soon! -- You have ordered: ${itemDetails}. We will connect with you soon on ${this.addressForm.value.phone}.`,
    };

    this.emailService.sendEmail(templateParams);
  }
}
